export const UNDELETE_TABLE='UNDELETE_TABLE'
export const UNDELETE_TABLE_SUCCESS= 'UNDELETE_TABLE_SUCCESS'
export const UNDELETE_TABLE_ERROR='DELETE_TABLE_ERROR'

export const UnDeleteTable= (data) => ({
    type: UNDELETE_TABLE,
    payload: data
});
